import React, { useCallback, useEffect, useMemo } from 'react';
import { Field, useField, useForm, useFormState } from 'react-final-form';
import PrimaryButton from '../../../../../../../components/Buttons/PrimaryButton';
import FieldArrayTable from '../../../../../../../components/Tables/FieldArrayTable';
import TableHeader from '../../../../../../../components/Tables/Table/components/TableHeader';
import ToggleField from '../../../../../../../components/ToggleField';
import DomainsTableRow from './components/DomainsTableRow';
import './styles.scss';

const Domains = ({ isLE }) => {
  const {
    mutators: { push, remove },
    change,
  } = useForm();
  const {
    values: { domains },
    dirty,
  } = useFormState();

  const {
    input: { value: forwardEmailByAutogenerated },
  } = useField('autogeneratedDomain');
  const addDomainRow = useCallback(() => {
    push('domains', { isClientUpdate: false });
  }, [push]);

  const removeDomainRow = useCallback(
    index => {
      remove('domains', index);
    },
    [remove],
  );
  const handleRadioClick = useCallback(
    indexRadio => {
      change(
        'domains',
        domains.map((domain, index) => ({ ...domain, isClientUpdate: index === indexRadio })),
      );
    },
    [change, domains],
  );

  const autogeneratedIndex = useMemo(() => {
    return domains.findIndex(el => el.isAutoGenerated);
  }, [domains]);

  const noAutogeneratedDomainAvailable = useMemo(() => {
    return autogeneratedIndex === -1;
  }, [autogeneratedIndex]);

  useEffect(() => {
    if (forwardEmailByAutogenerated && autogeneratedIndex > -1 && dirty) {
      handleRadioClick(autogeneratedIndex);
    }
  }, [forwardEmailByAutogenerated]);

  const TableControls = () => {
    return (
      <>
        <div className="ickyc-portal-domains__header">
          <h3>Domains</h3>
          <div>
            <PrimaryButton onClick={addDomainRow}>+ Add Domain</PrimaryButton>
          </div>
        </div>
        <Field
          disabled={noAutogeneratedDomainAvailable}
          component={ToggleField}
          name="autogeneratedDomain"
          label="Use autogenerated domain for “Request Client Update” and “Email Me A Link”"
        />
        {noAutogeneratedDomainAvailable && (
          <div className="ickyc-portal-domains__error-message">(No auto-generated domain available)</div>
        )}
      </>
    );
  };
  return (
    <div className="ickyc-portal-domains">
      <FieldArrayTable
        fieldName="domains"
        tableControls={TableControls}
        tableRow={DomainsTableRow}
        headerRow={TableHeader}
        onRemove={removeDomainRow}
        disableRadio={forwardEmailByAutogenerated}
        withRadioColumn
        onRadioClick={handleRadioClick}
        headerData={{
          items: [
            { type: 'radio', label: 'Default' },
            { type: 'codeSnippet' },
            { type: 'domainLink' },
            { type: 'domains', label: 'Domains' },
            { type: 'tags', label: 'Tags' },
            { type: 'remove' },
          ],
        }}
        noResultMessage="No Domains To Show"
        isLE={isLE}
      />
    </div>
  );
};

export default Domains;
